import type { ComponentProps, FC, PropsWithChildren } from 'react';
import { Container } from 'react-bootstrap';

import Footer from '@/components/Footer.tsx';
import Header from '@/components/Header/index.tsx';
import RegisteredWrapper from '@/components/RegisteredWrapper.tsx';
import UserTopContainer from '@/components/UserTopContainer.tsx';
import type TranslationKey from '@/lib/i18n/TranslationKey.ts';
import useTitle from '@/lib/useTitle.ts';

type FullLayoutProps = {
  title: TranslationKey;
  fluid?: ComponentProps<typeof Container>['fluid'];
};
const FullLayout: FC<PropsWithChildren<FullLayoutProps>> = ({ title, fluid, children }) => {
  useTitle(title);

  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="flex-grow-1 flex-shrink-1 d-flex flex-column pb-5">
        <Header />
        <RegisteredWrapper>
          <UserTopContainer />
          <Container fluid={fluid}>{children}</Container>
        </RegisteredWrapper>
      </div>
      <div className="flex-grow-0 flex-shrink-1">
        <Footer />
      </div>
    </div>
  );
};

export default FullLayout;
